var _style, _path, _defs, _polyline, _polyline2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCholesterol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AB1F25;}\n\t.st1{clip-path:url(#SVGID_00000041994684082294797460000004286526790348496779_);}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:1.0537;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#F8A087;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106111574140298306970000012048351897866688186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106111574140298306970000012048351897866688186_)"
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "3.6,61.2 15.1,61.2 19.2,47.3 26.5,77.9 29.2,63.2 35,63.2  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "79.4,61.6 87,61.6 89.4,71.9 95.8,42 100.7,72 104.4,55.2 112.1,55.2  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.8,43.2c0,0,2.9-8.6,14.3-8.6s19.3,14.2,9.5,26.5S56.9,85.6,56.9,85.6S38.8,69.9,31.3,58.5 s1.3-24.1,12.2-24.1S56.8,43.2,56.8,43.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCholesterol);
export default __webpack_public_path__ + "static/media/Cholesterol.1bf49bbbca755c85b188a0f436a44bca.svg";
export { ForwardRef as ReactComponent };